import { render, staticRenderFns } from "./SettingNewPasswordPanel.vue?vue&type=template&id=81a37e78&scoped=true&"
import script from "./SettingNewPasswordPanel.vue?vue&type=script&lang=js&"
export * from "./SettingNewPasswordPanel.vue?vue&type=script&lang=js&"
import style0 from "./SettingNewPasswordPanel.vue?vue&type=style&index=0&id=81a37e78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a37e78",
  null
  
)

export default component.exports